const scriptEditor = {
  templateUrl: '/modules/psa/script-editor/script-editor.html',
  controller: 'PSAController',
};

angular
  .module('psa.module')
  .component('scriptEditor', scriptEditor)
  .config(function ($stateProvider) {
    $stateProvider.state('psa', {
      url: '/psa',
      component: 'scriptEditor',
      resolve: {
        auth: function (userService, $state, eventService) {
          return userService
            .resolve(['PSA_USER'])
            .then(() => { })
            .catch(() => {
              eventService.trigger('userservice:unauthorized');
              $state.go('frontpage');
            });
        },
      },
    });
  });
